import {PrimaryPaneComponentConfig} from "../components/primary_pane_component";
import {getElementByElementOrId} from "../../../helpers/element";
import {PrimaryPane} from "../models/primary_pane";
import Collection from "../../../lib/collection";

export class PrimaryPaneManager {

    static new(parentElement, panesManager) {
        const element = parentElement.querySelector(PrimaryPaneComponentConfig.selector);
        if (!element) { return null }
        return new PrimaryPaneManager(element, panesManager)
    }

    constructor(id_or_element, panesManager) {
        const element = getElementByElementOrId(id_or_element);
        this.panesManager = panesManager;
        this.primaryPane = PrimaryPane.new(element, panesManager);
    }

    getPanesCollection() {
        return new Collection().concat([this.primaryPane]);
    }
}